<template>
  <div v-loading="tableLoading">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/setting/setting' }">系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>文字配置</el-breadcrumb-item>
      <el-link type="primary" style="float:right" @click="tosetting()"><i class="el-icon-back"></i> 返回</el-link>
    </el-breadcrumb>
    <div>
       <div class="flex-spc-x" style="width:100%;margin-top:30px;">
            <el-table
                             :data="ListWZStting"
                             tooltip-effect="dark"
                             border
                             stripe
                             style="width: 100%">
                            <el-table-column type="index" label="序号"  width="80" align="center"  ></el-table-column>
                             <el-table-column label="名称" width="300" prop="name">
                                <template slot-scope="scope">
                                  <span  v-if="scope.row.isEdit=='0'">  {{scope.row.name}}</span>
                                   <el-input placeholder="请输入"  v-if="scope.row.isEdit=='1'" v-model="scope.row.name" ></el-input>  
                               </template>

                             </el-table-column>
                            <el-table-column  label="功能介绍"  >
                                 <template slot-scope="scope">
                                  <span> {{scope.row.info}}</span>
                            </template>
                            </el-table-column>
                            <el-table-column label="操作" align="center" width="200">
                            <template slot-scope="scope">
                         <el-button type="text" @click="editSeetingClick(scope.row)" v-if="scope.row.isEdit=='0'" >修改</el-button>
                             <el-button type="primary" size="medium" @click="editsaverClick(scope.row)" v-if="scope.row.isEdit=='1' ">保存</el-button>
                             <el-button type="default"  @click="editcancelClick(scope.row)" v-if="scope.row.isEdit=='1' ">取消</el-button>
 
                            </template>
                        </el-table-column>
                        </el-table>
        
    </div>
    </div>
    </div> 
</template>
<script>
import CropperImage from "../../components/CropperImage";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
 
    DianList:[],
    SelectStoresID:localStorage.getItem("StoresID"),
    tableLoading:false,
    overtype:0,
    ListWZStting:[],
        WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
    shuaxing:false,
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      }
    
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
      tosetting(){
         this.$router.push({ path: '/setting/setting'})
      } ,
      getList(){

       this.tableLoading = true
       var data = { 
          SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
    
      }
     
      
        var that = this
      this.ajax('getListWZStting.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.ListWZStting = res.data
                if(that.shuaxing == true){
                    localStorage.setItem("WZHYName", res.WZHYName);
                    localStorage.setItem("WZPBName", res.WZPBName);
                    localStorage.setItem("WZXMName", res.WZXMName);
                    localStorage.setItem("WZYGName", res.WZYGName);
                    that.shuaxing = false
                    location. reload()
                }

          } 

      })
  
  
    }, editSeetingClick(val){
                val.isEdit = '1';
      }, editcancelClick(val){
                val.isEdit = '0';
      },editsaverClick(val){
         this.editWZSttingName(val.ID,val.name);
      }, editWZSttingName(SttingID,info){
                 this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SttingID:SttingID,
          SttingName:info
         }
     
      
        var that = this
         this.ajax('editWZSttingName.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.shuaxing = true
                that.getList();
                that.$message({
                  type: "success",
                  message: '保存成功',duration:2000,
                });
 
                }else{
                     that.$message({
                type: "error",
                message: res.Msg,duration:2000,
              });
                  
                 }

      })

             }
   
  }
}
</script>
 


// WEBPACK FOOTER //
// src/views/setting/TextSettingInfo.vue